export default __webpack_public_path__ + "7a75af1c92c910acf5cc2a864971418b.svg";